import { render, staticRenderFns } from "./TemplateOverview.vue?vue&type=template&id=12df6d4a"
import script from "./TemplateOverview.vue?vue&type=script&lang=ts"
export * from "./TemplateOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports